import React from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { theme } from "@answersnow/pkg-theme";
import { TABLE_BODY_CELL_SX } from "./constants";
import type { Task } from "./types";

interface TaskRowProps {
  task: Task;
  isLast: boolean;
  onSelect?: (task: Task) => void;
}

const TaskRowComponent: React.FC<TaskRowProps> = ({ task, isLast, onSelect }) => {
  const isInteractive = Boolean(onSelect);

  const handleKeyDown = (event: React.KeyboardEvent<HTMLTableRowElement>) => {
    if (!onSelect) return;
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onSelect(task);
    }
  };

  return (
    <TableRow
      aria-label={isInteractive ? `Select task ${task.name}` : undefined}
      data-testid={`task-row-${task.id}`}
      onClick={() => onSelect?.(task)}
      onKeyDown={isInteractive ? handleKeyDown : undefined}
      role={isInteractive ? "button" : undefined}
      tabIndex={isInteractive ? 0 : undefined}
      sx={{
        borderBottom: isLast ? "0px solid transparent" : "1px solid",
        borderColor: theme.palette.divider,
        cursor: onSelect ? "pointer" : "default",
        "&:hover": onSelect ? { bgcolor: theme.palette.action.hover } : undefined,
      }}
    >
      <TableCell sx={TABLE_BODY_CELL_SX}>{task.name}</TableCell>
      <TableCell sx={TABLE_BODY_CELL_SX}>{task.date}</TableCell>
    </TableRow>
  );
};

export const TaskRow = React.memo(TaskRowComponent);
